import { render, staticRenderFns } from "./StudipWizardDialog.vue?vue&type=template&id=672c3568&"
import script from "./StudipWizardDialog.vue?vue&type=script&lang=js&"
export * from "./StudipWizardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports